define('modules/form_editor/models/custom_gender',['require','exports','module','./dropdown','./custom_gender_item'],function(require, exports, module){
  "use strict";
  var DropDown = require("./dropdown"),
      CustomGenderItem = require("./custom_gender_item");

  var GENDERS = [{
    text: "male",
    value: 'M'
  }, {
    text: "female",
    value: 'F'
  }];

  module.exports = DropDown.extend({
    name: "custom:gender",
    hasIntegrableOptions: true,
    defaultValues: {
      firstOptionInvalid: true,
      showOtherOption: true,
      addOther: false
    },

    initialize: function(attrs,options){
      module.exports.__super__.initialize.call(this,attrs, _.extend({ itemModel: CustomGenderItem }, options));
      if (this.items.length === 1) {
        //first use of this model, no items yet
        this.items.first().set("translationKey", "editor.page.default");
        GENDERS.forEach(function(item){
          this.addItem({
            valid: true,
            translationKey: "formEditor.genders." + item.text,
            socialBinding: item.text,
            value: item.value
          });
        }.bind(this));
      } else {
        //we already had saved gender items
        var tKey = this.items.first().get("translationKey");
        //backwards compatibility, change saved translation key
        if(tKey === "formEditor.default"){
          this.items.first().set("translationKey", "formEditor.selectGender");
        }
      }
    },

    setAddOther: function(value) {
      this.set("addOther", value);
      if(value) {
        this.items.add({
          valid: true,
          translationKey: 'formEditor.genders.other'
        });
      } else {
        this.items.findWhere({translationKey: 'formEditor.genders.other'}).destroy();
      }
    }
  });

});

